import React from 'react';
import { CardActionArea, CardMedia, Stack, Typography, useTheme } from '@mui/material';

import { FavUnfavIcon } from '../FavUnfavIcon';
import { TruncatedTypography } from '../typography';
import { SvgColor } from '../svg-color';

interface Props {
  image: string;
  dishName: string;
  cookingTime: string;
  ratings: string;
  description: string;
  id: string;
  onClick?: VoidFunction;
}

const CARD_DIMENSIONS = {
  width: 200,
  height: 200,
};

const styles = {
  cardContainer: {
    ...CARD_DIMENSIONS,
    bgcolor: 'white',
    minWidth: '200px',
    borderRadius: '10px',
    boxShadow: '0px 2px 5px rgba(73, 67, 67, 0.2)',
    position: 'relative',
    overflow: 'hidden',
  },
  favIcon: {
    position: 'absolute' as const,
    top: '5px',
    right: '5px',
    color: 'red',
    backgroundColor: 'white',
    height: '25px',
    width: '25px',
  },
  cardMedia: {
    width: '100%',
    height: '50%',
    objectFit: 'cover' as const,
    borderTopRightRadius: '10px',
    borderTopLeftRadius: '10px',
  },
  icons: {
    fontSize: 10,
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
  },
};

const ProductCard: React.FC<Props> = ({
  image,
  id,
  dishName,
  cookingTime,
  ratings,
  description,
  onClick,
}) => {
  const theme = useTheme();

  return (
    <CardActionArea onClick={onClick} sx={styles.cardContainer}>
      <FavUnfavIcon id={id} style={styles.favIcon} />
      <CardMedia component="img" image={image} sx={styles.cardMedia} />
      <Stack sx={{ p: 1 }}>
        <Stack>
          <TruncatedTypography fontSize={14} fontWeight={'bold'} text={dishName} />
          <Typography
            fontSize={12}
            color={theme.palette.tertiary.shadyText}
            sx={{
              overflow: 'hidden',
              height: 40,
            }}
          >
            {description}
          </Typography>
        </Stack>

        <Stack sx={{ flexDirection: 'row', mb: 10 }}>
          {/* ------ */}
          <SvgColor
            src={`/assets/icons/ic_time.svg`}
            color={theme.palette.tertiary.shadyText}
            fontWeight={'bold'}
            sx={{ height: 14 }}
          />
          <Typography sx={styles.icons} color={theme.palette.tertiary.shadyText}>
            {cookingTime}
          </Typography>
          {/* ------- */}
          <SvgColor
            src={`/assets/icons/ic_star.svg`}
            color={theme.palette.tertiary.shadyText}
            fontWeight={'bold'}
            sx={{ height: 14 }}
          />
          <Typography sx={styles.icons} color={theme.palette.tertiary.shadyText}>
            {ratings}
          </Typography>
        </Stack>
      </Stack>
    </CardActionArea>
  );
};

export { ProductCard };
